import { API_URLS } from "@/api/urls";
import axiosInstance from "@/inteceptors";
import { useQuery } from "@tanstack/react-query";

export const useGetStates = (countryCode: string) => {
  return useQuery<State[]>({
    queryKey: ["states", countryCode],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URLS.SETTINGS.STATES}?country_code=${countryCode}`
      );
      return response.data;
    },
    enabled: !!countryCode,
  });
};
